<template>
  <modal background>
    <validable-form @submit="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ tag ? "Edycja tagu" : "Nowy tag" }}</p>
          <button
            class="delete"
            type="button"
            aria-label="close"
            @click="cancel"
          ></button>
        </header>

        <section class="modal-card-body content">
          <div class="field">
            <label class="label">Nazwa</label>
            <control-input
              type="text"
              ref="name"
              v-model.trim="name"
              icon-left="fa-tag"
              placeholder="Aktualności..."
              rules="required"
            />
          </div>
        </section>

        <footer class="modal-card-foot">
          <button
            class="button is-success"
            type="submit"
            :class="{ 'is-loading': submitting }"
            :disabled="submitting"
          >
            <icon :name="tag ? 'fa-save' : 'fa-plus'" />
            <span>{{ tag ? "Zapisz" : "Dodaj" }}</span>
          </button>
          <button class="button" type="button" @click="cancel">Anuluj</button>
        </footer>
      </div>
    </validable-form>
  </modal>
</template>

<script>
import { Modal } from "%modals";
import { Icon, ValidableForm, ControlInput } from "%helpers";
import WithServerValidation from "%mixins/WithServerValidation"; // Fixme: it should be imported with { } braces, however it doesn't work

export default {
  name: "video-tag-model",

  components: {
    Modal,
    Icon,
    ValidableForm,
    ControlInput
  },

  mixins: [
    WithServerValidation({
      "name:UNIQUE": "Istnieje już tag o podanej nazwie"
    })
  ],

  props: {
    tag: Object,
    onSubmit: Function
  },

  data() {
    return {
      name: "",
      submitting: false
    };
  },

  mounted() {
    this.name = this.tag ? this.tag.name : "";
  },

  methods: {
    submit() {
      if (!this.submitting) {
        this.submitting = true;

        this.onSubmit({ name: this.name })
          .then(() => this.cancel())
          .catch(this.handleValidationError)
          .finally(() => (this.submitting = false));
      }
    },

    cancel() {
      this.$emit("hide");
    }
  }
};
</script>

<style></style>
